import './ReservedStockCard.scss';

interface IReservedStockCard {
  orderId: number;
  quantity: number;
  stockProductsIds: number[];
  isLast: boolean;
}

const ReservedStockCard = ({ orderId, quantity, isLast }: IReservedStockCard) => {
  const orderLink = `Order-${orderId}`;
  const orderCount = `${quantity} ${quantity > 1 ? 'unidades' : 'unidad'}`;

  const handleOrderLinkClick = () => {
    window.open(`/order/details/${orderId}`, '_blank');
  };

  return (
    <div className="reservedStockCard">
      <div className="reservedStockCardContainer">
        <div className="reservedStockCardLink" onClick={handleOrderLinkClick}>
          {orderLink}
        </div>
        <div className="reservedStockCardCount">{orderCount}</div>
      </div>
      {!isLast && <div className="dividerSeparator" />}
    </div>
  );
};

export default ReservedStockCard;
